import { apiClient } from "./client";
import axios from "axios";
import {
  FormMeta,
  FormState,
  FormSubmitRequest,
  FormSubmitResponse,
  UploadUrlRequest,
  UploadUrlResponse,
  ViewFileRequest,
  ViewFileResponse,
} from "../types";

export const formApi = {
  getMeta: async (token: string): Promise<FormMeta> => {
    const response = await apiClient.get<FormMeta>(`/form/meta?token=${token}`);
    return response.data;
  },

  getState: async (token: string): Promise<FormState> => {
    const response = await apiClient.get<FormState>(`/form/state?token=${token}`);
    return response.data;
  },

  submit: async ({
    token,
    data,
  }: {
    token: string;
    data: FormSubmitRequest;
  }): Promise<FormSubmitResponse> => {
    const response = await apiClient.post<FormSubmitResponse>(`/form/submit?token=${token}`, data);
    return response.data;
  },

  getUploadUrl: async (token: string, request: UploadUrlRequest): Promise<UploadUrlResponse> => {
    const response = await apiClient.post<UploadUrlResponse>(
      `/form/upload?token=${token}`,
      request
    );
    return response.data;
  },

  uploadFile: async (url: string, file: File): Promise<void> => {
    try {
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
        timeout: 60000, // 60 second timeout for large files
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload progress: ${percentCompleted}%`);
          }
        },
      });
    } catch (error) {
      // Enhance error message for network errors
      if (axios.isAxiosError(error)) {
        if (error.code === "ERR_NETWORK" || error.message?.includes("Network Error")) {
          throw new Error(
            "Network error: Unable to upload file. Please check your internet connection."
          );
        } else if (error.code === "ECONNABORTED") {
          throw new Error("Upload timeout: File is too large or connection is too slow.");
        } else if (error.response) {
          throw new Error(`Upload failed: ${error.response.status} ${error.response.statusText}`);
        }
      }
      throw error;
    }
  },

  getViewUrl: async (token: string, request: ViewFileRequest): Promise<ViewFileResponse> => {
    const response = await apiClient.post<ViewFileResponse>(`/form/view?token=${token}`, request);
    return response.data;
  },
};
